import React from "react";

const TextBox = ({
  className,
  placeholder,
  value,
  onChange,
  name,
  readOnly,
  memberId,
  type,
}) => {
  return (
    <input
      type={type || "text"}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      readOnly={readOnly}
      disabled={memberId ? true : false}
      style={{ paddingLeft: "0.5rem" }}
    />
  );
};

export default TextBox;
